module.exports = __webpack_public_path__ + "img/user.a0236b1e.png";